<template>
  <div class="modal fade" id="changeNegotiationModal" ref="modalEle" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Zmień negocjacje dla wybranego zamówienia
          </h5>
          <button type="button" class="close ms-auto" data-bs-dismiss="modal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>
          <div class="mb-3 col-md-6">
            <label>Ustaw negocjacje dla poniższych zamówień:</label>
            <select class="form-select form-select-sm" v-model="newSelectedNegotiation">
              <option
                v-for="negotiation in negotiations"
                :key="negotiation.id"
                :value="negotiation.id"
                :disabled="(negotiation.id === 3 && hasZeroRabate) || (negotiation.id === 4 && hasRabate)"
              >
                {{ negotiation.name }}
              </option>
            </select>
          </div>
          <div class="table-responsive mt-5">
            <table class="table table-striped">
              <thead>
                <th>Numer zamówienia</th>
                <th class="text-end">Negocjacja</th>
              </thead>
              <tbody>

                <template v-for="group in groupedOrders" :key="group.order_number">
                  <tr style="background:#f8f9fa;font-weight:600;">
                    <td>
                      {{ group.order_number }}
                    </td>
                    <td class="text-end">
                      {{ group.negotiation_by_name ?? '' }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            <i class="bi bi-x-square me-2"></i>
            Zamknij
          </button>
          <form @submit.prevent="submitForm">
            <button type="submit" class="btn btn-primary">
              <i class="bi bi-save me-2"></i>
              Zapisz
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { router } from '@inertiajs/vue3';

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
  computed: {
    newSelectedNegotiationName() {
      const selected = this.negotiations.find(
        s => s.id === Number(this.newSelectedNegotiation)
      );

      return selected ? selected.name : '';
    },

    hasZeroRabate() {
      return (this.selectedRecords || []).some(
        record => Number(record.rabate) === 0
      );
    },

    hasRabate() {
      return (this.selectedRecords || []).some(
        record => Number(record.rabate) > 0
      );
    },

    groupedOrders() {
      const groups = {};

      (this.selectedRecords || []).forEach(record => {
        const orderNo = record.order_list?.order_number ?? 'BRAK';

        if (!groups[orderNo]) {
          groups[orderNo] = {
            order_number: orderNo,
            negotiation_by_name: record.order_list?.negotiation_by_name ?? '',
            records: []
          };
        }

        groups[orderNo].records.push(record);
      });

      return Object.values(groups);
    }

  },

  props: {
    selectedRecords: Array,
    userID: Number,
    negotiations: Array
  },

  watch: {
    selectedRecords: {
      handler(newVal) {
        if (newVal?.length) {
          this.newSelectedNegotiation =
            newVal[0].order_list?.negotiation ?? null;

          this.error = null;
        }

        if (
          (this.hasZeroRabate && Number(this.newSelectedNegotiation) === 3) ||
          (this.hasRabate && Number(this.newSelectedNegotiation) === 4)
        ) {
          this.newSelectedNegotiation = null;
        }
      },
      immediate: true
    },

    hasZeroRabate(newValue) {
      if (
        newValue &&
        Number(this.newSelectedNegotiation) === 3
      ) {
        this.newSelectedNegotiation = null;
      }
    },

    hasRabate(newValue) {
      if (
        newValue &&
        Number(this.newSelectedNegotiation) === 4
      ) {
        this.newSelectedNegotiation = null;
      }
    }
  },

  data() {
    return {
      newSelectedNegotiation: null,
      error: null,
      expandedOrders: {}
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);

    this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
      this.$emit('clear-selection');
    });
  },

  methods: {
    toggleOrder(orderNumber) {
      this.expandedOrders[orderNumber] = !this.expandedOrders[orderNumber];
    },

    async submitForm() {

      if (
        this.hasZeroRabate &&
        Number(this.newSelectedNegotiation) === 3
      ) {
        this.error = 'Nie można wybrać tej negocjacji, ponieważ jeden z zaznaczonych rekordów ma rabat 0%.';
        return;
      }

      if (
        this.hasRabate &&
        Number(this.newSelectedNegotiation) === 4
      ) {
        this.error = 'Nie można wybrać tej negocjacji, ponieważ jeden z zaznaczonych rekordów ma rabat.';
        return;
      }

      const orderNumbers = this.groupedOrders.map(
        group => group.order_number
      );

      axios.post(route('orderList.change-negotiation'), {
        orderNumbers: orderNumbers,
        negotiation_id: this.newSelectedNegotiation
      })
        .then(() => {

          this.$emit('added-success', 'Zmieniono negocjacje poprawnie');
          this.$emit('updated-article', true);
          this.$emit('clear-selection');
          this.hide();

        })
        .catch(error => {
          this.error = error.response?.data;
          console.log('error', error);
        });
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },

    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>
